import { getDeviceInfo } from './deviceInfo';

export const popsclTrack = async (eventName, uuid, data) => {
  const shopifyYCookie = document.cookie.split('; ').find(row => row.startsWith('_shopify_y='));
  const clientId = shopifyYCookie ? shopifyYCookie.split('=')[1] : null;
  const timestamp = Date.now();
  const randomNum = Math.floor(Math.random() * 1e6);
  const identifier = `${uuid}-${timestamp}-${randomNum}`;
  const deviceInfo = await getDeviceInfo();

  try {
    return await fetch('https://tracking.popscl.io/track', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        clientId: clientId,
        name: eventName,
        source_context: data.source_context || 'customer_portal',
        data: data,
        timestamp: new Date().toISOString(),
        id: identifier,
        device_info: {
          ...deviceInfo,
        }
      })
    });
  } catch (error) {
    console.warn('Failed to track event:', eventName, error);
  }
}
